import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class SharedSubjectModel {

  private _categorySubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);


  set categorySubject(value: BehaviorSubject<string>) {
    this._categorySubject = value;
  }

  get categorySubject(): BehaviorSubject<string> {
    return this._categorySubject;
  }

  getCategorySubject() {
    return this._categorySubject.asObservable();
  }
}
